import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../../../Context/Layout.context';
import { createRoleName } from '../../../services/rolesAndPermissions/rolesAndPermissions.service';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { RoleEditor } from './../RoleEditor/RoleEditor.component';

interface AddRoleProps {
  onClose: () => void;
  onChange: () => void;
}

export const AddRole: React.FC<AddRoleProps> = ({ onClose, onChange }) => {
  const handleClose = () => {
    onClose();
  };
  const { t } = useTranslation();
  useDocumentTitle(t('roles:header.addRoleButton'));
  const { openAlert } = useLayoutContext();

  const handleSave = (id: string, roleName: string, roleDescription: string) => {
    createRoleName(roleName, roleDescription).then(
      () => {
        openAlert('success');
        onClose();
        onChange();
      },
      () => {
        openAlert('error');
      },
    );
  };

  return (
    <RoleEditor
      title={t('roles:header.addRoleButton')}
      onCancel={handleClose}
      onSave={handleSave}
      onChange={onChange}
      roleName={''}
      roleDescription={''}
      roleId={''}
    />
  );
};
